import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NotificationsService } from 'angular2-notifications';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { UserService } from '../../../app/services/user.service';

const defaults = {
    notif: {
        timeOut: 3000,
        showProgressBar: true,
        pauseOnHover: false,
        clickToClose: true,
        maxLength: 50
    }
}
@Component({
    selector: 'app-addexchangewithdrawal',
    templateUrl: './addexchangewithdrawal.component.html',
    styleUrls: ['./addexchangewithdrawal.component.css']
})
export class AddExchangeWithdrawal {
    element: any = {};
    currencyList: any = [];
    myForm: any = FormControl;
    exchangeList = [];
    exchangeAsset = [];
    exchange = '';
    currency = '';
    constructor(
        public dialogRef: MatDialogRef<AddExchangeWithdrawal>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private notifSer: NotificationsService,
        public fb: FormBuilder,
        public userService: UserService,
    ) {
        this.getExchangeList();
        this.getCurrencyList();
        this.element = data;
        this.myForm = this.fb.group({
            exchange: ['', [Validators.required]],
            currency: ['', [Validators.required]],
            whitelist_address_key: ['', [Validators.required]],
            amount: ['', [Validators.required]],
        });
        this.userService.csrf().subscribe((response) => {
            this.data['_csrf'] = response._csrf;
            
          });
    }

    //  Get exchanges
    getExchangeList() {
        this.userService.getExchanges().subscribe(response => {
            let data = response.map(function (item) {
                return { exchange: item.ExchangeName };
            })
            this.exchangeList = data.filter(name => name.exchange != 'BEST').sort((a, b) => a.exchange > b.exchange ? 1 : -1);
        })
    }
    getCurrencyList() {
        this.userService.getAllCurrency().subscribe(list => {
            this.currencyList = list.sort((a, b) => a.CurrencySymbol > b.CurrencySymbol ? 1 : -1);
        });
    }
    exchangeSelection(event) {
        console.log(event);
        this.exchange = event;       
    }
    currencySelection(event) {
        console.log(event);
        this.currency = event;
       this.getExchangeAssetList()
    }
    getExchangeAssetList() {
        console.log(this.exchange, this.currency, 'exchange asset list')
        this.userService.getExchangeAsset().subscribe(list => {
            this.exchangeAsset = list.filter(item => (item.exchange_name === this.exchange) && (item.internal_currency === this.currency));
            console.log(this.exchangeAsset);
        });
    }

    // Save Form to database
    saveExchangeWithdrawal() {
        const { notif } = defaults
        if (this.element) {

            if (!this.myForm.value['exchange']) {
                return this.notifSer.error('Error', 'Please fill the Exchange', notif);
            }
            if (!this.myForm.value['currency']) {
                return this.notifSer.error('Error', 'Please fill the Currency', notif);
            }
            if (!this.myForm.value['amount']) {
                return this.notifSer.error('Error', 'Please fill the Amount', notif);
            }
            this.userService.csrf().subscribe(success => {
                this.myForm.value._csrf = success['_csrf'];
                const result = {...this.myForm.value, data: this.exchangeAsset}

                this.userService.saveExchangeWithdraw(result).subscribe(response => {
                    if (response) {
                        this.notifSer.success('Success', response.message, notif)
                        // Emit the form data when closing the dialog
                        this.dialogRef.close({ success: true, data: response });
                    } else this.notifSer.error('Error', response.message, notif);
                });
            })

        }
    }

}


// WEBPACK FOOTER //
// ./src/app/exchangewithdrawal/addexchangewithdrawal/addexchangewithdrawal.component.ts